import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import CoreCapabilities from '../components/CoreCapabilities';
import HowItWorks from '../components/HowItWorks';
import KeyFeatures from '../components/KeyFeatures';
import Integrations from '../components/Integrations';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import ChatWidget from '../components/ChatWidget';
import ErrorBoundary from '../components/ErrorBoundary';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0b]">
      <Header />
      <main>
        <ErrorBoundary section="Hero">
          <HeroSection />
        </ErrorBoundary>
        
        <ErrorBoundary section="Core Capabilities">
          <CoreCapabilities />
        </ErrorBoundary>
        
        <ErrorBoundary section="How It Works">
          <HowItWorks />
        </ErrorBoundary>
        
        <ErrorBoundary section="Key Features">
          <KeyFeatures />
        </ErrorBoundary>
        
        <ErrorBoundary section="Integrations">
          <Integrations />
        </ErrorBoundary>
        
        <ErrorBoundary section="Testimonials">
          <Testimonials />
        </ErrorBoundary>
        
        <ErrorBoundary section="FAQ">
          <FAQ />
        </ErrorBoundary>
      </main>
      <Footer />
      <ChatWidget />
      <react-widget-uv
        agent_id="d06dbaf0-eab9-4ef0-a0f7-cea5b286d69b"
        schema="1474c4bd-bba8-4a0a-b087-155446e262b9"
        type="thunderemotionlite"
        data-testid="side-widget-uv"
      ></react-widget-uv>
    </div>
  );
};

export default HomePage;
